import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import EmployeeDetail from './pages/EmployeeDetail';
import Attendance from './pages/Attendance';
import Requests from './pages/Requests';
import Branches from './pages/Branches';
import AdminDashboard from './pages/AdminDashboard';
import Managers from './pages/Managers';
import TrainingCourses from './pages/TrainingCourses';
import Payroll from './pages/Payroll';
import AttendanceKiosk from './pages/AttendanceKiosk';
import KioskLockListener from './components/KioskLockListener';

const theme = createTheme({
  palette: {
    primary: {
      main: '#03447a',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <KioskLockListener />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/terminal" element={<AttendanceKiosk />} />

            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="employees" element={<Employees />} />
              <Route path="employees/:id" element={<EmployeeDetail />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="training" element={<TrainingCourses />} />
              <Route path="requests" element={<Requests />} />
              <Route path="branches" element={<Branches />} />
              <Route path="managers" element={<Managers />} />
              <Route path="admin" element={<AdminDashboard />} />
              <Route path="payroll" element={<Payroll />} />
            </Route>

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
